<template>
  <div>
    <div class="loader" v-if="showLoader">
      <CSpinner
        style="width:3rem;height:3rem;"
        color="primary"
      />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {getPermissions} from "@/helpers/Helpers"; // don't remove this line as it is required in router file to include

export default {
  name: 'App',
  computed: {
    showLoader(){
      return this.$store.state.showLoader;
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .loader{
    text-align: center;
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 999999;
    opacity: 0.5;
    background-color: #fff;
    >div{
      position: absolute;
      top: 50%;
    }
  }
  .error_msg{
    color: brown;
  }
  .form-group{
    margin: 0;
  }
  .deleteBtn{
        background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 14px;
        opacity: 1;
        color: #009FE3;
        font-weight: bold;
        padding: 10px 25px;
        font-size: 1rem;
    }
    .addBtn{
        background: #009FE3 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 14px;
        opacity: 1;
        font-weight: bold;
        padding: 10px 25px;
        font-size: 1rem;
        color: #FFFFFF;
    }
  .top_buttons{
      background-color: #00000029;
      padding: 5px 10px;
      border-radius: 5px;
      margin-bottom: 20px;
  }
  label.required::after{
      content: '*';
      color: red;
  }
  .pagination li {
    padding: 5px 10px;
    border: 1px solid #ddd;
  }
  .pagination > .active  {
    z-index: 2;
    color: #fff;
    cursor: default;
    background-color: #337ab7;
    border-color: #337ab7;
  }
  .pagination > .active > a:focus {
    outline: none;
    box-shadow: none;
  }
</style>
